import { Async, Resolved, Rejected, AsyncErrorHandling } from '../../../../common/async';
import { requestToken } from '../../auth-service';
import { AuthState, withAuth } from '../../context/auth-context';
import { Navigate, useSearchParams } from 'react-router';

const AuthRedirect = ({ login }: AuthState) => {
    const [searchParams] = useSearchParams();
    const oneTimeToken = searchParams.get('login_id');

    return (
        <Async promiseFn={() => requestToken(oneTimeToken)}>
            <Resolved>
                {token => {
                    login(token);
                    return <Navigate to="/teams" />;
                }}
            </Resolved>
            <Rejected>{error => <AsyncErrorHandling error={error} />}</Rejected>
        </Async>
    );
};

export default withAuth()(AuthRedirect);
